import React, {Component, Fragment} from "react"
import {InputGroup, Input} from 'reactstrap'
import Select from 'react-select'
import classNames from "classnames"
import {API} from '@utils'
import {textOperators, numberOperators, selectOperators} from '@src/assets/data/constants'
import AsyncSelectWithActions from '../AsyncSelectWithActions'
import InputGroupButtonDropdown from "./InputGroupButtonDropdown"
import {getOperatorByValue} from './Utils'

class UncontrolledInputGroupBuilder extends Component {
	constructor(props) {
		super(props)
		let operator = {}
		if (props.type === 'text') operator = _.head(this.getInputOperators('text'))
		if (props.type === 'number') operator = _.head(this.getInputOperators('number'))
		if (_.includes(['select', 'asyncSelect'], props.type))  operator = _.head(this.getSelectOperators())
		this.default = {
			operator,
			firstInput: '',
			secondInput: '',
			focus: false
		}
		this.state = this.default
	}

	initComponent() {
		if (_.size(this.props.value) === 0) {
			this.setState({
				value: this.props.value,
				...this.default
			})
		}

		if (_.size(this.props.value) === 1) { 
			const data = _.head(this.props.value)
			const prepareState = {
				value: this.props.value,
				operator: getOperatorByValue(this.props.type, data)
			}
			if (_.includes(['text', 'number'], this.props.type)) {
				const ـvalue = _.isArray(data.value) ? data.value : [data.value]
				this.setState(() => {
					return {
						firstInput: _.get(ـvalue, 0, ''),
						secondInput: _.get(ـvalue, 1, ''), 
						...prepareState
					}
				})

			}
			if (_.includes(['select', 'asyncSelect'], this.props.type)) {
				this.loadSelectBuilder(data).then(options => {
					this.setState(() => {
						return {
							firstInput: options,
							secondInput: '', 
							...prepareState
						}
					})
				})
			}
		}
	}

	componentDidMount() {
		this.initComponent()
	}

	componentDidUpdate(prevProps) {
		if (_.isEqual(prevProps.value, this.props.value)) return
		this.initComponent()
	}

	loadSelectBuilder = (data) => {
		if (_.isEmpty(data.value) || data.value === 'null') {
			return new Promise(resolve => resolve([]))
		}

		const value = _.isArray(data.value) ? data.value : [data.value]

		if (_.size(data.options) > 0) {
			return new Promise(resolve => resolve(data.options))
		} 

		// check if all item of array is object 
		const isObjectArray = _.every(value, _.isObject)
		
		if (isObjectArray) {
			return new Promise(resolve => resolve(value))
		}

		const valueArray = _.map(value, v => (_.isNumber(v) ? v.toString() : v))
		
		if (this.props.type === 'select') {
			return new Promise(resolve => {
				resolve(
					_.filter(this.props.options, o => {
						return _.includes(valueArray, o.value?.toString())
					})
				)
			})
		} 
		
		if (this.props.type === 'asyncSelect') {
			return new Promise((resolve) => {
				this.asyncSelectLoadOptions('', valueArray).then(options => resolve(options))
			})
		}
	}

	getInputOperators = (type) => {
		if (type === 'text') {
			return this.filterOperators(type, textOperators)
		}
		if (type === 'number') {
			return this.filterOperators(type, numberOperators)
		}
	}

	getSelectOperators = (type) => {
		return this.filterOperators(type, selectOperators, this.props.isMulti)
	}
	
	filterOperators = (type, operators, isMulti = false) => {
		return this.props.filterOperators ? this.props.filterOperators({ type, operators, isMulti }) : operators 
	}

	resetValueOnOperatorChange = (name, { value }, { operator, firstInput, secondInput }) => {
		let stateInputs = {} 
		if (name === 'operator') {
			if (value === 'bt' && operator.value !== 'bt') {
				stateInputs = {firstInput: '', secondInput: ''}
			} 
			if (value !== 'bt' && operator.value === 'bt') {
				stateInputs = {firstInput: ''}
			}
			if (firstInput === 'null') {
				stateInputs = {firstInput: ''}
			}
		}
		return stateInputs
	}

	onChangeStateCallback = () => {
		const {operator, firstInput, secondInput} = this.state
		const options = _.includes(['select', 'asyncSelect'], this.props.type) ? firstInput : []
		const not = !_.isNil(operator.not) ? operator.not : false
		const valueIsNull = _.has(operator, 'null') ? operator.null : false 
		let value = !_.includes(['select', 'asyncSelect'], this.props.type) 
			? operator.value === 'bt' ? [firstInput, secondInput] : firstInput
			: _.map(firstInput, o => o.value)
		if (valueIsNull) value = 'null'
		if (this.props.onChange) {
			this.props.onChange([{ operator: operator.value, value, options, not }])
		}
	}

	onSelectChangeStateCallback = () => {
		const {operator, firstInput: options} = this.state
		const not = !_.isNil(operator.not) ? operator.not : false
		const valueIsNull = _.has(operator, 'null') ? operator.null : false 
		let value = _.map(options, o => o.value.toString())
		if (valueIsNull) value = 'null'
		if (this.props.onChange) {
			this.props.onChange([{ operator: operator.value, value, options, not }])
		}
	}

	onOperatorChange = (name, option) => {
		this.setState((state) => {
			const stateInputs = this.resetValueOnOperatorChange(name, option, state)
			return {
				...stateInputs,
				[name]: option,
				focus: false
			}
		}, this.onChangeStateCallback)
	}

	onValueChange = (name, value) => {
		this.setState(() => {
			return {
				[name]: value
			}
		}, this.onChangeStateCallback)
	}

	onSelectValueChange = (name, value) => {
		this.setState(() => {
			return {
				[name]: value
			}
		}, this.onSelectChangeStateCallback)
	}

	onInputGroupBuilderFocus = (isFocus) => {
		this.setState({
			focus: isFocus
		})
	}

	asyncSelectLoadOptions = async (inputValue, ids = []) => {
		const { data } =  await API.get(this.props.remoteUrl, {
			params: { 
				q: inputValue,
				ids,
				limit: 20
			}
		})
		return _.map(data, (v, k) => {
			return this.props.remoteUrlFormatter ? this.props.remoteUrlFormatter(v) : {value: v.id, label: v.name}
		})
	}

	onInputKeyDown = (e) => {
		e.stopPropagation()
		if (this.props.type === 'number' && e.key === 'e') {
			e.preventDefault()
		}
	}

	render() {
		const isDisplayInputs = !_.includes(['is-null', 'is-not-null'], _.get(this.state, 'operator.code'))
		let operators = {}
		if (this.props.type === 'text')  operators = this.getInputOperators('text')
		if (this.props.type === 'number')  operators = this.getInputOperators('number')
		if (_.includes(['select', 'asyncSelect'], this.props.type))  operators = this.getSelectOperators(this.props.type)
		return (
      <InputGroup className={classNames('input-group-builder', { focus: this.state.focus })} onFocus={() => this.onInputGroupBuilderFocus(true)} onBlur={() => this.onInputGroupBuilderFocus(false)}>
				{_.includes(['select', 'asyncSelect'], this.props.type) && (
					<Fragment>
						<InputGroupButtonDropdown fullWidth={!isDisplayInputs} options={operators} value={_.get(this.state, "operator")} onChange={(option) => this.onOperatorChange("operator", option)}/>
						{isDisplayInputs && (
							<Fragment>
								{this.props.type === 'select' && (
									<Select 
										className="w-100"
										classNamePrefix={'react-select-builder'} 
										// The filter panel scrolls (`.dataTable-filter-scroll`, overflow-y: auto),
										// which clipped this menu to a couple of visible options and left it
										// fighting the sticky table header for stacking order. Portal it to
										// <body> so it escapes the scroll container; z-index clears the
										// panel's own 1060.
										menuPortalTarget={document.body}
										closeMenuOnScroll={e => e.target.classList && !e.target.classList.contains('react-select-builder__menu-list')}
										styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
										value={_.get(this.state, "firstInput", [])} 
										options={this.props.options} 
										isMulti={this.props.isMulti} 
										autoFocus={this.props.autoFocus}
										onChange={(e) => {
											const value = this.props.isMulti ? e : [e]
											this.onSelectValueChange("firstInput", value)
										}}
									/>
								)}
								{this.props.type === 'asyncSelect' && (
									<AsyncSelectWithActions 
										className="w-100"
										classNamePrefix={'react-select-builder'} 
										// Same clipping/stacking problem as the sync Select above.
										menuPortalTarget={document.body}
										closeMenuOnScroll={e => e.target.classList && !e.target.classList.contains('react-select-builder__menu-list')}
										styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
										value={_.get(this.state, "firstInput", [])} 
										cacheOptions
			              defaultOptions
										loadOptions={this.asyncSelectLoadOptions}
							      optionFormatter={this.props.optionFormatter}
										isMulti={this.props.isMulti} 
										autoFocus={this.props.autoFocus}
										onChange={(e) => {
											const value = this.props.isMulti ? e : [e]
											this.onSelectValueChange("firstInput", value)
										}}
									/>
								)}
							</Fragment>
						)}
					</Fragment>
				)}
				{_.includes(['text', 'number'], this.props.type) && (
					<Fragment>
						<InputGroupButtonDropdown fullWidth={!isDisplayInputs} options={operators} value={_.get(this.state, "operator")} onChange={(option) => this.onOperatorChange("operator", option)}/>
						{isDisplayInputs && (
							<Fragment>
								{_.get(this.state, 'operator.value') === 'bt' && (
									<Fragment>
										<Input type={this.props.type} value={_.get(this.state, "firstInput", '')} onChange={(e) => this.onValueChange("firstInput", e.target.value)} autoFocus={this.props.autoFocus} onKeyDown={this.onInputKeyDown}/>
										<Input type={this.props.type} value={_.get(this.state, "secondInput", '')} onChange={(e) => this.onValueChange("secondInput", e.target.value)} onKeyDown={this.onInputKeyDown}/>
									</Fragment>
								)}
								{_.get(this.state, 'operator.value') !== 'bt' && (
									<Input type={this.props.type} value={_.get(this.state, "firstInput", '')} onChange={(e) => this.onValueChange("firstInput", e.target.value)} autoFocus={this.props.autoFocus} onKeyDown={this.onInputKeyDown}/>
								)}
							</Fragment>
						)}
					</Fragment>
				)}
			</InputGroup>
    )
	}
}

export default UncontrolledInputGroupBuilder